const Joi = require('joi')
const fields = require('../fields')

const createItemCollectionSchema = Joi.object({
    name: fields.nameField.required(),
    description: fields.descriptionField.optional(),
    imgUrl: fields.urlField.optional().label('Image URL'),
})

module.exports = createItemCollectionSchema